import { Injectable } from '@angular/core';
import { SubjectService } from './subject.service';
import { AppSettings } from '../enums/app-settings.enum';
import { TranslateService } from '@ngx-translate/core';
import { UtilitiesService } from '../utilities/utilities.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';
import { SuccessComponent } from '../shared/success/success.component';
import { SkuDataService } from './sku-data.service';
import { AddonSubscriptionDataService } from './addon-subscription-data.service';
import { ErrorComponent } from '../shared/error/error.component';
import { ProductService } from './product.service';

@Injectable({
  providedIn: 'root',
})
export class AddonSubscriptionService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  ismobileScreen: boolean;
  locale: string;
  userEnv: string;
  TIME_ARRAY = [
    '12:00',
    '12:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
  ];

  AM_PM: any = ['AM', 'PM'];
  travelInsuranceAdded: boolean = false;
  tandConditionClasses: string =
    'ion-modal-uplift eand-partail-height-screen-bottom-mobile eand-partail-height-screen-bottom-90';
  constructor(
    private http: HttpClient,
    private SS: SubjectService,
    private translate: TranslateService,
    private UTS: UtilitiesService,
    private modalController: ModalController,
    private SKUDS: SkuDataService,
    private ASDS: AddonSubscriptionDataService,
    private productService: ProductService
  ) {
    this.ismobileScreen = this.UTS.isMobileDevice();
    this.locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    this.userEnv = this.UTS.getENV();
  }

  addAddonLoggedIn(
    paymentMethod: any,
    price: any,
    smilePointsOfUser: any,
    mobileNumber: any,
    sku: any,
    autoRenew: any,
    quantity: any,
    accountId: any,
    selectedFregement: any,
    countrycode: any,
    callForwardNumber: any,
    reminderTime: any,
    reminderAmPm: any,
    reminderDate: any,
    reminderDateTime: any,
    LoggedIn: any,
    isATPostpaid: any
  ) {
    this.UTS.clearError();
    let link = '/addAddonsLoggedIn';
    if (paymentMethod == 2) {
      if (parseInt(price) > smilePointsOfUser) {
        this.UTS.error('Error! Not Enough Smile Points');
        return;
      }
    }
    let specialInput = [];
    localStorage.setItem('mobileNumber', mobileNumber);
    const payload = {
      accountNo: mobileNumber,
      accountNumber: null,
      addonId: sku?.skuId,
      skuid: null,
      validate: false,
      type: autoRenew == true ? 'AUTO_RENEWAL' : 'ONE_TIME',
      quantity: quantity,
      specialInputs: specialInput,
      locale: this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
      forwardCountryCode: null,
      forwardCountryNumber: null,
      reminder_date_time: null,
    };
    if (payload['preferredNumbers']) {
      delete payload['preferredNumbers'];
    }
    if (paymentMethod == 2) {
      payload['paymentMethod'] = 'loyalty';
    }
     //DBB-5104
     this.travelInsuranceAdded = localStorage.getItem('isTravelInsuranceAddon') ? true : false;
     if(this.travelInsuranceAdded){
      localStorage.setItem('travelInsuranceAddonPayload', JSON.stringify(payload));
    }
    //DBB-5104 end
    if (this.isAddonRecommended(sku?.skuId)) {
      payload['isRecommended'] = true;
    }
    payload.accountNo = accountId;
    payload['preferredNumbers'] = mobileNumber;
    link = '/addAddonsLoggedIn';
    const ocrResponse = JSON.parse(localStorage.getItem('OCR_RESPONSE'));
    if (
      sku &&
      sku?.productType &&
      sku?.productType == AppSettings.KIDS_ADDONS &&
      ocrResponse &&
      ocrResponse?.documentId
    ) {
      payload['kidEIDNumber'] = ocrResponse?.documentId;
    }
    if (sku && sku?.productType == 'BRIDGE_ADDON') {
      if (selectedFregement == 0) {
        payload.forwardCountryCode = countrycode;
        payload.forwardCountryNumber = callForwardNumber.replace(
          countrycode,
          ''
        );

        let specialForwardCountryCodeObject = {
          fieldName: 'forward_country_code',
          fieldValue: payload.forwardCountryCode,
        };
        let specialForwardCountryNumberObject = {
          fieldName: 'forward_country_number',
          fieldValue: payload.forwardCountryNumber,
        };
        payload.specialInputs.push(specialForwardCountryCodeObject);
        payload.specialInputs.push(specialForwardCountryNumberObject);
      } else {
        let [hours, minutes] = reminderTime.split(':');
        if (hours == '12') {
          hours = '00';
        }

        if (reminderAmPm == 'PM') {
          hours = parseInt(hours, 10) + 12;
        }

        let time = hours + ':' + minutes + ':00';
        let date =
          reminderDate.day +
          '/' +
          (reminderDate.month - 1) +
          '/' +
          reminderDate.year;

        reminderDateTime = date + ' ' + time;

        payload.reminder_date_time = reminderDateTime;
        let specialReminderDateTimeObject = {
          fieldName: 'reminder_date_time',
          fieldValue: payload.reminder_date_time,
        };
        payload.specialInputs.push(specialReminderDateTimeObject);
      }

      if (LoggedIn) {
        link = '/addAddOn';
        payload.skuid = sku?.skuId;
        payload.accountNumber = accountId;
      }

      this.addAddons(payload, link).subscribe(
        (r: any) => {
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: mobileNumber,
                price: price,
                billType: isATPostpaid
                  ? 1
                  : paymentMethod && paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
                addonType: sku?.productType,
              });
              let catID = '';
              if (localStorage.getItem('CAT')) {
                catID = localStorage.getItem('CAT');
              }
              this.navigatrToSuccssScreen();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
          this.SS.enableSubscribeButtonAgain.next(true);
        },
        (e) => {
          this.UTS.log(e);
          this.SS.enableSubscribeButtonAgain.next(true);
          if (e?.error?.errorDescription &&
            e?.error?.errorDescription?.toUpperCase()
              .search(AppSettings.ERROR_CRM_016) != -1
          ) {
            this.openBottomSheet(SuccessComponent, {
              isFreeParentalEligible: true,
            });
            return;
          }
          this.updateErrorMessage(e, this.locale);
        }
      );
    } else {
      this.addAddons(payload, link).subscribe(
        (r: any) => {
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: mobileNumber,
                price: price,
                billType: isATPostpaid
                  ? 1
                  : paymentMethod && paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
              });
              this.navigatrToSuccssScreen();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
          this.SS.enableSubscribeButtonAgain.next(true);
        },
        (e) => {
          this.UTS.log(e);
          this.SS.enableSubscribeButtonAgain.next(true);
          if (e?.error?.errorDescription &&
            e?.error?.errorDescription?.toUpperCase()
              .search(AppSettings.ERROR_CRM_016) != -1
          ) {
            this.openBottomSheet(SuccessComponent, {
              isFreeParentalEligible: true,
            });
            return;
          }
          this.updateErrorMessage(e, this.locale);
        }
      );
    }
  }

  addAddon(
    paymentMethod: any,
    price: any,
    smilePointsOfUser: any,
    mobileNumber: any,
    sku: any,
    autoRenew: any,
    quantity: any,
    accountId: any,
    selectedFregement: any,
    countrycode: any,
    callForwardNumber: any,
    reminderTime: any,
    reminderAmPm: any,
    reminderDate: any,
    reminderDateTime: any,
    LoggedIn: any,
    isATPostpaid: any
  ) {
    this.UTS.clearError();
    let link = '/addAddons';
    if (paymentMethod == 2) {
      if (parseInt(price) > smilePointsOfUser) {
        this.UTS.error('Error! Not Enough Smile Points');
        return;
      }
    }
    let specialInput = [];
    localStorage.setItem('mobileNumber', mobileNumber);
    const payload = {
      accountNo: mobileNumber,
      accountNumber: null,
      addonId: sku.skuId,
      skuid: null,
      validate: false,
      type: autoRenew == true ? 'AUTO_RENEWAL' : 'ONE_TIME',
      quantity: quantity,
      specialInputs: specialInput,
      locale: this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
      forwardCountryCode: null,
      forwardCountryNumber: null,
      reminder_date_time: null,
      gamingAddon: false,
    };
    const subCategoryId = localStorage.getItem('subCategoryId');
    const ocrResponse = JSON.parse(localStorage.getItem('OCR_RESPONSE'));
    if (
      sku &&
      sku?.productType &&
      sku?.productType == AppSettings.KIDS_ADDONS &&
      ocrResponse &&
      ocrResponse?.documentId
    ) {
      payload['kidEIDNumber'] = ocrResponse?.documentId;
      payload.specialInputs.push({
        fieldName: 'kidEIDNumber',
        fieldValue: ocrResponse?.documentId,
      });
    }
    if (payload['preferredNumbers']) {
      delete payload['preferredNumbers'];
    }
    if (paymentMethod == 2) {
      payload['paymentMethod'] = 'loyalty';
    }

    if (sku && sku.productType == 'BRIDGE_ADDON') {
      if (selectedFregement == 0) {
        payload.forwardCountryCode = countrycode;
        payload.forwardCountryNumber = callForwardNumber.replace(
          countrycode,
          ''
        );

        let specialForwardCountryCodeObject = {
          fieldName: 'forward_country_code',
          fieldValue: payload.forwardCountryCode,
        };
        let specialForwardCountryNumberObject = {
          fieldName: 'forward_country_number',
          fieldValue: payload.forwardCountryNumber,
        };
        payload.specialInputs.push(specialForwardCountryCodeObject);
        payload.specialInputs.push(specialForwardCountryNumberObject);
      } else {
        let [hours, minutes] = reminderTime.split(':');
        if (hours == '12') {
          hours = '00';
        }

        if (reminderAmPm == 'PM') {
          hours = parseInt(hours, 10) + 12;
        }

        let time = hours + ':' + minutes + ':00';
        let date =
          reminderDate.day +
          '/' +
          (reminderDate.month - 1) +
          '/' +
          reminderDate.year;

        reminderDateTime = date + ' ' + time;

        payload.reminder_date_time = reminderDateTime;
        let specialReminderDateTimeObject = {
          fieldName: 'reminder_date_time',
          fieldValue: payload.reminder_date_time,
        };
        payload.specialInputs.push(specialReminderDateTimeObject);
      }

      if (LoggedIn) {
        link = '/addAddOn';
        payload.skuid = sku.skuId;
        payload.accountNumber = accountId;
      }

      this.addAddons(payload, link).subscribe(
        (r: any) => {
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: mobileNumber,
                price: price,
                billType: isATPostpaid
                  ? 1
                  : paymentMethod && paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
                addonType: sku.productType,
              });
              let catID = '';
              if (localStorage.getItem('CAT')) {
                catID = localStorage.getItem('CAT');
              }
              this.navigatrToSuccssScreen();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
          this.SS.enableSubscribeButtonAgain.next(true);
        },
        (e) => {
          this.UTS.log(e);
          this.SS.enableSubscribeButtonAgain.next(true);
          if (e?.error?.errorDescription &&
            e?.error?.errorDescription?.toUpperCase()
              .search(AppSettings.ERROR_CRM_016) != -1 ||
            e?.error?.message.toUpperCase().search(AppSettings.ERROR_CRM_016) !=
            -1 ||
            e?.error?.newErrorCode
              .toUpperCase()
              .search(AppSettings.ERROR_CRM_016) != -1
          ) {
            // eligible for free parental addon subscription
            this.openBottomSheet(SuccessComponent, {
              isFreeParentalEligible: true,
            });
            return;
          }
          this.updateErrorMessage(e, this.locale);
        }
      );
    } else {
      //DBB-5104
     this.travelInsuranceAdded = localStorage.getItem('isTravelInsuranceAddon') ? true : false;
     if(this.travelInsuranceAdded){
      localStorage.setItem('travelInsuranceAddonPayload', JSON.stringify(payload));
    }
    //DBB-5104 end
      this.addAddons(payload, link).subscribe(
        (r: any) => {
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: mobileNumber,
                price: price,
                billType: isATPostpaid
                  ? 1
                  : paymentMethod && paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
              });
              if (r?.token) {
                localStorage.setItem('travelInsuranceToken', r?.token);
              }
              let catID = '';
              if (localStorage.getItem('CAT')) {
                catID = localStorage.getItem('CAT');
              }
              this.navigatrToSuccssScreen();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
          this.SS.enableSubscribeButtonAgain.next(true);
        },
        (e) => { 
          this.UTS.log(e);
          this.SS.enableSubscribeButtonAgain.next(true);
          if ( e?.error?.errorDescription &&
            e?.error?.errorDescription?.toUpperCase()
              .search(AppSettings.ERROR_CRM_016) != -1 ||
            e?.error?.message.toUpperCase().search(AppSettings.ERROR_CRM_016) !=
            -1 ||
            e?.error?.newErrorCode
              .toUpperCase()
              .search(AppSettings.ERROR_CRM_016) != -1
          ) {
            // eligible for free parental addon subscription
            this.openBottomSheet(SuccessComponent, {
              isFreeParentalEligible: true,
            });
            return;
          }
          this.updateErrorMessage(e, this.locale);
        }
      );
    }
  }

  private isAddonRecommended(skuId): boolean {
    let findRecommendedAddonAvailable = false;
    const ADDON_RECOMMENDATION_LIST = JSON.parse(
      localStorage.getItem('ADDON_RECOMMENDATION_LIST')
    );
    if (ADDON_RECOMMENDATION_LIST && ADDON_RECOMMENDATION_LIST?.length > 0) {
      findRecommendedAddonAvailable = ADDON_RECOMMENDATION_LIST.find(
        (x) => x?.skuId == skuId
      )
        ? true
        : false;
    }
    return findRecommendedAddonAvailable;
  }

  public updateErrorMessage(e, lang) {
    let eMessage = '';
    if (this.UTS.getLocaleLanguage() == 'en') {
      if (
        e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
        e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 ||
        e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
        e?.error?.message == AppSettings.ERROR_VAL_00080 ||
        e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
      ) {
        this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00015 ||
        e?.error?.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
      ) {
        this.translate.get('ERROR_VAL_00015').subscribe((message) => {
          //   this.UTS.error(message);
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00305) {
        this.translate.get('ERROR_VAL_00305').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00167) {
        this.translate.get('ERROR_VAL_00167').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00303) {
        this.translate.get('ERROR_VAL_00303').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        e?.error?.errorDescription == AppSettings.ERROR_CBCM_00002 ||
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00180
      ) {
        this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00227) {
        this.translate.get('ERROR_VAL_00227').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_IN_00002) {
        this.translate.get('ERROR_IN_00002').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
        e?.error?.message == AppSettings.ERROR_VAL_00011 ||
        e?.error?.message == AppSettings.ERROR_VAL_00002 ||
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
      ) {
        this.translate.get('ERROR_VAL_00011').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00011)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00061)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00133)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00013))
      ) {
        this.translate.get('ERROR_VAL_00011').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
        this.translate.get('COMS_00001').subscribe((message) => {
          eMessage = message;
        });
      } else if (e.error && e.error.errorDescription && !eMessage) {
        const errorObj = this.UTS.searchValidationErrorCode(
          e.error.errorDescription
        );
        if (errorObj) {
          eMessage =
            lang === 'ar'
              ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr)
              : errorObj?.errorTextEn;
        } else {
          if (e.error && e.error.newErrorCode && !eMessage) {
            const errorObj = this.UTS.searchValidationErrorCode(
              e.error.newErrorCode
            );
            if (errorObj) {
              eMessage =
                lang === 'ar'
                  ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr)
                  : errorObj?.errorTextEn;
            }
          }
        }
      } else {
        eMessage = e?.error?.errorDescription;
      }
    } else {
      if (
        e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
        e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 ||
        e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
        e?.error?.message == AppSettings.ERROR_VAL_00080 ||
        e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
      ) {
        this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00015 ||
        e?.error?.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
      ) {
        this.translate.get('ERROR_VAL_00015').subscribe((message) => {
          //   this.UTS.error(message);
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00305) {
        this.translate.get('ERROR_VAL_00305').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00167) {
        this.translate.get('ERROR_VAL_00167').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00303) {
        this.translate.get('ERROR_VAL_00303').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00227) {
        this.translate.get('ERROR_VAL_00227').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        e?.error?.errorDescription == AppSettings.ERROR_CBCM_00002 ||
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00180
      ) {
        this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription == AppSettings.ERROR_IN_00002) {
        this.translate.get('ERROR_IN_00002').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
        e?.error?.message == AppSettings.ERROR_VAL_00011 ||
        e?.error?.message == AppSettings.ERROR_VAL_00002 ||
        e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
      ) {
        this.translate.get('ERROR_VAL_00011').subscribe((message) => {
          eMessage = message;
        });
      } else if (
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00011)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00061)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00133)) ||
        (e?.error &&
          e?.error?.errorDescription &&
          e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
        (e?.error &&
          e?.error?.message &&
          e?.error?.message.includes(AppSettings.VAL_00013))
      ) {
        this.translate.get('ERROR_VAL_00011').subscribe((message) => {
          eMessage = message;
        });
      } else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
        this.translate.get('COMS_00001').subscribe((message) => {
          eMessage = message;
        });
      } else if (e.error && e.error.errorDescription && !eMessage) {
        const errorObj = this.UTS.searchValidationErrorCode(
          e.error.errorDescription
        );
        if (errorObj) {
          eMessage =
            lang === 'ar'
              ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr)
              : errorObj?.errorTextEn;
        } else {
          if (e.error && e.error.newErrorCode && !eMessage) {
            const errorObj = this.UTS.searchValidationErrorCode(
              e.error.newErrorCode
            );
            if (errorObj) {
              eMessage =
                lang === 'ar'
                  ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr)
                  : errorObj?.errorTextEn;
            }
          }
        }
      } else {
        eMessage = e?.error?.errorDescriptionAr;
      }
    }
    this.openBottomSheet(ErrorComponent, eMessage, 'verification-modal modal-fullscreen ion-modal-uplift eand-partail-height-screen-bottom-50 eand-partail-height-screen-bottom-70-mobile');
    this.SS.addonBuyError.next(eMessage);
    this.SS.addonBuySuccessfully.next({ success: false, data: e });
  }

  private addAddons(payload: any, link: string) {
    return this.http.post(
      `${environment.BASE_URL}` + link,
      payload,
      this.httpOptions
    );
  }

  public async openBottomSheet(
    component: any,
    data,
    classes = 'verification-modal modal-fullscreen'
  ) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: classes,
    });
    return await modal.present();
  }

  checkTravelInsuranceAddon(sku) {
    if (sku && sku.rewardList && sku.rewardList.length > 0) {
      sku.rewardList.forEach((item) => {
        if (item.key && item.key == 'travelInsurance') {
          return true;
        }
      });
    }
  }

  setTravelInsuranceAddon(sku: any) {
    if (sku && sku?.rewardList && sku?.rewardList?.length > 0) {
      sku.rewardList.forEach((item) => {
        if (item.key && item.key == 'travelInsurance') {
          this.ASDS?.setTravelInsurance(item);
        }
      });
    }
  }

  redirectionAddonSubscriptionPage(sku: any, roaming: any, cat: any,arena: any) {
    let subCategory = localStorage.getItem('subCategoryId');
    this.SS.skuDetails.next(sku);
    this.SKUDS.set(sku);
    this.setTravelInsuranceAddon(sku);
    const kidsAddon =
      sku && sku?.productType && sku?.productType == AppSettings.KIDS_ADDONS
        ? true
        : false;
    const url =
      `/addon-subscription?subCategory=${subCategory ? subCategory : cat
      }&skuId=${sku?.skuId}&roaming=${roaming ? true : false
      }&kidsAddon=${kidsAddon}&travelInsurance=${this.ASDS?.getTravelInsurance() ? true : false
      }&lang=${this.UTS.getLocaleLanguage()?.toLocaleLowerCase()}&areaProAddon=${arena}`;
    this.SS.routingService.next(url)
  }
  navigatrToSuccssScreen() {
    const url =
      `/success?&lang=${this.UTS.getLocaleLanguage().toLocaleLowerCase()}`
    this.SS.routingService.next(url);
  }

  openDetailPage(sku: any) {
    const url = `/detail?skuId=${sku?.skuId}&lang=${this.UTS.getLocaleLanguage().toLocaleLowerCase()}`;
    this.SS.routingService.next(url);
  }

  

  checkAccountType(type: any, valid) {
    this.productService.getAccountType(type).subscribe(
      (res: any) => {
        if (
          res &&
          (res?.accountType?.toLowerCase() == 'prepaid' ||
            res?.accountType?.toLowerCase() == 'postpaid')
        ) {
          return valid(true);
        } else {
          return valid(false);
        }
      },
      (err) => {
        return valid(false);
      }
    );
  }
}
